export const createCartItemData = (sku, quantity = 1, isConsentGiven) => {
    const data = { sku, quantity };
    if (isConsentGiven === undefined)
        return data;
    const entered_options = [
        {
            uid: btoa("custom-option/has_registration_consent"),
            value: isConsentGiven,
        },
    ];
    // according to codegen value should be a string but actually it needs to be a boolean :/
    data.entered_options = entered_options;
    return data;
};
//# sourceMappingURL=createCartItemData.js.map